<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ $t("headers.recurringEvents") }}</h3>
            </div>
            <div class="card-body">
                <table class="table table-striped table-hover table-responsive-md text-center">
                    <thead>
                        <tr>
                            <th>{{ $t("repeatingEvents.event") }}</th>
                            <th>{{ $t("repeatingEvents.startAt") }}</th>
                            <th>{{ $t("repeatingEvents.finishAt") }}</th>
                            <th>{{ $t("repeatingEvents.frequency") }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="repeatingEvents.length">
                        <tr v-for="event in repeatingEvents" :key="event.id" class="align-middle">
                            <td>
                                {{ event.title }}
                            </td>
                            <td>{{ event.repeat_from ? $d(new Date(event.repeat_from), "short") : "--" }}</td>
                            <td>
                                {{ event.repeat_to ? $d(new Date(event.repeat_to), "short") : "--" }}
                            </td>
                            <td>{{ event.interval_days }}</td>
                            <td>
                                <button class="btn btn-primary btn-sm me-2" @click="goTo(event.id)">
                                    <icon icon="Search"></icon>
                                </button>
                                <button v-if="$store.getters.hasGatehousePerm('delete_patrollog')"
                                    class="btn btn-danger btn-sm" @click.stop="deleteEvent(event.id)">
                                    <icon icon="Trash"></icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="6" class="text-center text-muted py-3">
                                {{ $t("repeatingEvents.notFound") }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="totalCount > 0" class="d-flex justify-content-between mx-4">
                    <Paginate
                        :page-count="totalPages"
                        :click-handler="handlePageChange"
                        :prev-text="'«'"
                        :next-text="'»'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :active-class="'active'"
                        :disabled-class="'disabled'"
                    />
                    <div class="flex-shrink-0">
                        <select v-model.number="perPage" class="form-select form-select-sm" style="height: 40px;">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="50">50</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Icon from '@/components/Icon.vue';
import Paginate from 'vuejs-paginate-next';

export default {
    components: {
        Icon,
        Paginate,
    },
    data() {
        return {
            repeatingEvents: [],
            currentPage: 1,
            perPage: 10,
            totalCount: 0,
            totalPages: 0,
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData(page = 1) {
            this.currentPage = page;

            this.$store.getters.api.get(`/${this.$route.params.slug}/repeating-events`, {
                params: {
                    page: this.currentPage,
                    page_size: this.perPage,
                }
            })
                .then(response => {
                    this.repeatingEvents = response.data.results;
                    this.totalCount = response.data.count;
                    this.totalPages = Math.ceil(this.totalCount / this.perPage);
                })
                .catch(error => {
                    console.error("Error loading repeating events", error);
                });
        },
        goTo(eventId) {
            this.$router.push({
                name: "RepeatingEventDetailView",
                params: {
                    slug: this.$route.params.slug,
                    id: eventId,
                }
            })
        },
        deleteEvent(eventId) {
            const confirm = window.confirm(this.$t("utils.deleteQuestion"));
            if (!confirm) return;

            this.$store.getters.api.delete(`/${this.$route.params.slug}/repeating-events/${eventId}/delete`)
                .then(() => {
                    this.loadData();
                })
                .catch(error => {
                    console.error("Error deleting repeating event", error);
                });
        },
        handlePageChange(page) {
            this.loadData(page);
        }
    },
    watch: {
        perPage() {
            this.currentPage = 1;
            this.loadData();
        }
    }
}
</script>